import React from 'react';
import { IntervalOption } from '../types';

interface IntervalSelectorProps {
  selectedInterval: IntervalOption;
  onIntervalChange: (interval: IntervalOption) => void;
}

const IntervalSelector: React.FC<IntervalSelectorProps> = ({ 
  selectedInterval, 
  onIntervalChange 
}) => {
  const intervals: IntervalOption[] = ['1초', '5초', '10초', '30초', '1분', '5분'];

  return (
    <div className="interval-selector">
      <label htmlFor="interval-select" className="interval-label">
        데이터 수집 주기:
      </label>
      <select
        id="interval-select"
        value={selectedInterval}
        onChange={(e) => onIntervalChange(e.target.value as IntervalOption)}
        className="interval-select"
      >
        {intervals.map((interval) => (
          <option key={interval} value={interval}>
            {interval}
          </option>
        ))}
      </select>
    </div>
  );
};

export default IntervalSelector;
